import { useState } from 'react';
import {
  Box,
  IconChevronRight16,
  IconLess16,
  IconMore16,
  InteractableContainer,
  Link,
  Stack,
  Text,
} from '@stitch-fix/mode-react';
import { isNonEmptyString } from '../../utils/helpers';

type FAQLink = {
  href?: string;
  text?: string;
};

interface FAQItem {
  answer: string;
  link?: FAQLink;
  question: string;
}

export interface FAQsProps {
  items: FAQItem[];
  title?: string;
}

const shouldRenderLink = (link?: FAQLink) =>
  isNonEmptyString(link?.href) && isNonEmptyString(link?.text);

export const FAQ = ({ answer, link, question }: FAQItem) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <InteractableContainer
      icon={isExpanded ? <IconLess16 /> : <IconMore16 />}
      iconLabel={isExpanded ? 'Show less' : 'Show more'}
      iconPosition="left"
      m="0 auto"
      maxWidth="510px"
      onClickIcon={() => setIsExpanded(!isExpanded)}
      py="12px"
    >
      <Box
        ml="50px"
        onClick={() => setIsExpanded(!isExpanded)}
        style={{ cursor: 'pointer' }}
      >
        <Text setting="title-xsmall">{question}</Text>
      </Box>
      {isExpanded && (
        <Stack ml="50px" mt="8px" spacing={0.5}>
          <Text setting="body-medium-fixed">{answer}</Text>
          {shouldRenderLink(link) && (
            <Link
              endIcon={<IconChevronRight16 title="Go to link" />}
              href={link?.href}
              size="tertiary"
            >
              {link?.text}
            </Link>
          )}
        </Stack>
      )}
    </InteractableContainer>
  );
};

export const FAQs = ({ items, title }: FAQsProps) => {
  return (
    <Stack spacing={1}>
      <Text align="center" setting="title-medium">
        {title ?? 'FAQs'}
      </Text>
      <>
        {items.map(item => {
          return (
            <div key={item.question}>
              <FAQ
                answer={item.answer}
                link={item.link}
                question={item.question}
              />
            </div>
          );
        })}
      </>
    </Stack>
  );
};
